<template>
  <div>
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>

    <v-toolbar flat dense class="custom-toolbar">
      <v-toolbar-title>Student Document Details</v-toolbar-title>
      <v-divider class="mx-4" inset vertical></v-divider>
    </v-toolbar>
    <!-- {{student_documents_list}}--- -->
    <v-data-table style="margin: 20px" :headers="headers" :items="student_documents_list" class="elevation-1"
      sort-by="name" :search="search" hide-default-header>
      <!-- Header slot to apply background color -->
      <template v-slot:header="{ props }">
        <thead>
          <tr>
            <th v-for="header in props.headers" :key="header.value" class="custom-header">
              {{ header.text }}
            </th>
          </tr>
        </thead>
      </template>
      <template v-slot:top>
        <v-toolbar flat dense color="white">
          <v-spacer></v-spacer>
          <v-text-field v-model="search" append-icon="search" label="Search" style="padding: 10px" single-line
            hide-details>
          </v-text-field>
          <span style="width: 20px"></span>

          <v-dialog v-model="dialog" max-width="800px">
            <template v-slot:activator="{ on }">
              <v-btn class="button" v-on="on" small>Upload Documents</v-btn>
            </template>

            <v-card>
              <v-card-title class="custom-toolbar">
                <span class="headline">{{ formTitle }}</span>
              </v-card-title>

              <v-card-text>
                <v-container>
                  <v-row dense justify="center" class="mt-3">
                    <v-col cols="12" sm="8" md="8" v-for="field in docfields" :key="field.field_name"
                      v-if="field.isactive">

                      <!-- Label -->
                      <div class="pl-1 pb-2" style="font-size: 14px;">
                        <b>{{ field.label }}</b>
                        <v-icon v-if="field.required" class="pl-1 pb-2" color="error">*</v-icon>
                      </div>

                      <!-- Select -->
                      <v-select v-if="field.input_type === 'select' && !field.multiple" v-model="document_type"
                        :items="field.options" item-text="name" item-value="id" :readonly="!field.iseditable"
                        :filled="!field.iseditable" dense outlined rounded @change="getDocumentConfig(document_type)"
                        :prepend-icon="true ? 'mdi-file' : 'mdi-file'" />

                      <!-- File -->
                      <v-file-input v-if="field.input_type === 'file' && field.iseditable" v-model="file"
                        prepend-icon="mdi-upload" show-size dense outlined :readonly="!field.iseditable"
                        :filled="!field.iseditable" @change="handleFileChange" />
                      <p v-if="field.input_type === 'file' && file">
                        File Height: {{ fileHeight }}, File Width: {{ fileWidth }}
                      </p>
                      <!-- Text -->
                      <v-text-field v-if="field.input_type === 'text'" v-model="remark" :readonly="!field.iseditable"
                        :filled="!field.iseditable" dense outlined rounded
                        :rules="field.required ? [v => !!v || field.label + ' is required'] : []" />

                    </v-col>

                  </v-row>

                  <v-row dense justify="center" class="mt-3">
                    <v-btn text class="button-77" @click="uploadDocument()">
                      <v-icon dark>mdi-cloud-upload</v-icon> Upload
                    </v-btn>
                  </v-row>
                  <v-row dense justify="center" v-if="req_imagetype_doc">
                    <b style="color: red">
                      File Should Be In {{ req_imagetype_doc }} Format And Size
                      Of Uploading Documents Should Be <= {{ req_imagetype_size }} MB </b>
                  </v-row>
                  <v-row dense justify="center" v-if="documentheight">
                    <b style="color: red">
                      image Height Should Be <= {{ documentheight }} And Width Should Be <={{ documentwidth }} </b>
                  </v-row>

                </v-container>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <!-- <v-btn class="button" @click="save">Save</v-btn> -->
                <v-btn class="button" @click="close()">Cancel</v-btn>
              </v-card-actions>

            </v-card>
          </v-dialog>

        </v-toolbar>
      </template>

      <template v-slot:[`item.document_path`]="{ item }">
        <span v-if="item.document_path">
          <v-btn text color="primary" icon title="download">
            <a :href="basepath + item.document_path" target="_blank" style="text-decoration: none">
              <v-icon>mdi-eye</v-icon>
            </a>
          </v-btn>
        </span>
        <span v-else>-</span>
      </template>
      <template v-slot:item.action="{ item }">
        <div>
          <v-avatar style="" size="20" class="edit-avatar">
            <v-icon color="red" class="delete-v-icon mr-2" @click="deleteAttachment(item)">delete</v-icon>
          </v-avatar>
        </div>
      </template>
    </v-data-table>
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <div class="text-center">
      <v-dialog v-model="dialog_upload" hide-overlay persistent width="300">
        <v-card color="primary" dark>
          <v-card-text>
            Please wait..
            <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>
<script>
  import axios from "axios";
  import "@/assets/css/color.css"; // css needs to be imported for each dashboard
  export default {
    props: {
      learner: {
        type: [String, Number], // Adjust type based on your actual value
        required: true,
      },
    },
    data() {
      return {
        upload_image_loader: false,
        delete_load: false,
        dialog: false,
        overlay: false,
        dialog_upload: false,
        snackbar_msg: "",
        child_div_id: "",
        color: "",
        learner: "",
        snackbar: false,
        search: "",

        headers: [
          {
            text: "Sr. No.",
            align: "left",
            sortable: false,
            value: "srno",
          },

          {
            text: "Document Name",
            align: "left",
            sortable: false,
            value: "document_name",
          },
          {
            text: "View File",
            align: "left",
            sortable: true,
            value: "document_path",
          },
          {
            text: "Remark",
            align: "left",
            sortable: true,
            value: "document_remark",
          },

          { text: "Actions", value: "action", sortable: false },
        ],
        document_type_list: [],
        student_documents_list: [],
        docfields: [],
        req_imagetype_doc: null,
        req_imagetype_size: null,
        documentheight: null,
        documentwidth: null,
        isdimentionrequired: false,
        isvaliddimantions: true,

        documenttype: "",
        document_type: "",
        req_imagetype_doc: null,
        remark: null,
        file: null,
        fileHeight: null,
        fileWidth: null,
      };
    },
    watch: {
      learner(newVal, oldVal) {
        if (newVal) {
          this.getStudentDocuments();
        }
      },

      overlay(val) {
        val = () => {
          this.overlay = false;
        };
      },
    },
    computed: {
      formTitle() {
        return this.editedIndex === -1
          ? "Upload Documents Form"
          : "Upload Documents Form";
      },
    },
    mounted() {
      this.basepath = localStorage.getItem("awspath");
      this.learner = localStorage.getItem("learner_for_profile");
      if (this.learner) {
        this.getStudentDocuments();
      }
    },
    methods: {
      close() {
        this.dialog = false;
      },
      getStudentDocuments() {
        const formData = {
          learner: this.learner,
        };

        // Optional: show loader if needed
        this.comp_load = true;

        axios
          .post("/parent/getStudentDocuments", formData)
          .then((res) => {
            const data = res.data;
            if (data && data.flag === "YES") {
              this.student_documents_list = data.student_documents_list;
              this.docfields = data.docfields;
              this.document_type_list = data.document_type_list;
              this.child_div_id = data.child_div_id;
            } else {
              this.showSnackbar(
                "#ff9800",
                data.message || "Unable to fetch Document data."
              );
            }
          })
          .catch((error) => {
            console.error("Error in getStudentDocuments:", error);
            this.showSnackbar(
              "#b71c1c",
              "Something went wrong while fetching activities!"
            );
          })
          .finally(() => {
            this.comp_load = false;
          });
      },
      deleteAttachment(item) {
        if (!confirm("Are you sure you want to delete this document?")) return;
        this.delete_load = true;
        const data = {
          learner_id: this.learner,
          doc_id: item.document_id,
        };

        axios
          .post("/Admission/deleteDocument", data)
          .then((res) => {
            this.delete_load = false;
            if (res.data.status == "YES") {
              this.student_documents_list = res.data.student_documents_list;
              this.showSnackbar("#4caf50", "Document deleted successfully..."); // show snackbar on success
            } else {
              this.showSnackbar("#b71c1c", "Something went wrong!"); // show snackbar
            }
          })
          .catch((error) => {
            this.delete_load = false;
            window.console.log(error);
          })
          .finally(() => {
            //close loader
            this.delete_load = false;
          });
      },
      uploadDocument() {

        for (const field of this.docfields) {
          if (field && field.isactive && field.required) {
            let val;
            // Map field_name to the correct v-model variable
            if (field.field_name === 'document_type') {
              val = this.document_type;
            } else if (field.field_name === 'document_file') {
              val = this.file;
            } else if (field.field_name === 'document_remark') {
              val = this.remark;
            }

            if (field.input_type === 'file') {
              if (!val) {
                this.showSnackbar('error', `${field.label} is required`);
                return false;
              }
            } else {
              const trimmedVal = val !== null && val !== undefined ? String(val).trim() : '';
              if (trimmedVal === '') {
                this.showSnackbar('error', `${field.label} is required`);
                return false;
              }
            }
          }
        }


        // if (this.documenttype == null || this.documenttype == '') {
        //   this.showSnackbar("#b71c1c", "Please select Documen Type");
        //   return;
        // }
        // if (this.file == null) {
        //   this.showSnackbar("#b71c1c", "Please select file");
        //   return;
        // }
        let formData = new FormData();
        formData.append("file", this.file);
        formData.append("ldid", this.child_div_id);
        formData.append("documenttype", this.document_type);
        formData.append("fileHeight", this.fileHeight);
        formData.append("fileWidth", this.fileWidth);
        formData.append("remark", this.remark);
        this.upload_image_loader = true;

        axios
          .post("/Admission/saveUploadStudentDocuments", formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          })
          .then((res) => {
            if (res.data.status == "YES") {
              this.showSnackbar("#4caf50", "Document uploaded successfully");
              this.document_type = null;
              this.student_documents_list = res.data.student_documents_list;
              this.dialog = false;
            } else if (res.data.status == "NOF") {
              this.showSnackbar("#b71c1c", res.data.fmsg);
            } else if (res.data.status == "NO") {
              this.showSnackbar("#b71c1c", res.data.fmsg);
              this.file = null;
              this.dialog = false;
            } else {
              this.showSnackbar("#b71c1c", "Something went wrong!!!");
              sessionStorage.setItem("error-trace", res.data.error_trace);
            }
            this.upload_image_loader = false;
          })
          .catch((error) => {
            // alert("in else catch");
            this.showSnackbar("#b71c1c", "Something went wrong!!!");
            this.upload_image_loader = false;
          })
          .finally(() => {
            this.upload_image_loader = false;
            this.file = null;
            this.remark = null;
            this.dialog = false;
          });
      },
      getDocumentConfig(item) {
        // alert("item---" + JSON.stringify(item));
        const data = {
          document: item,
        };
        axios
          .post("/Icard/getDocumentConfig", data)
          .then((res) => {
            this.req_imagetype_doc = res.data.imagetype;
            this.req_imagetype_size = res.data.documentfilesize;
            this.documentheight = res.data.documentheight;
            (this.documentwidth = res.data.documentwidth),
              (this.isdimentionrequired = res.data.isdimentionrequired);
          })
          .catch((error) => {
            alert("Somthing went wrong!!!");
          })
          .finally(() => { });
      },
      handleFileChange() {
        // alert("in handle file change");
        if (this.isdimentionrequired == false) {
          return;
        }
        const selectedFile = this.file;
        if (selectedFile) {
          this.file = selectedFile;
          const reader = new FileReader();
          reader.onload = (e) => {
            const img = new Image();
            img.onload = () => {
              this.fileHeight = img.height;
              this.fileWidth = img.width;
              if (
                this.fileHeight > this.documentheight ||
                this.fileWidth > this.documentwidth
              ) {
                alert("Height And Width Not Matching..");
                this.isvaliddimantions = false;
              } else {
                this.isvaliddimantions = true;
              }
            };
            img.src = e.target.result;
          };
          reader.readAsDataURL(selectedFile);
        }
      },
      showSnackbar(clr, msg) {
        this.snackbar = true;
        this.color = clr;
        this.snackbar_msg = msg;
      },
    },
  };
</script>
<style scoped>
  .slide {
    color: red;
    font-weight: bold;
    margin-left: 10px;
    font-size: 80%;
  }

  .mytable /deep/ thead th {
    background: #0f2027 !important;
    /* fallback for old browsers */
    background: -webkit-linear-gradient(to right,
        #2c5364,
        #203a43,
        #0f2027) !important;
    /* Chrome 10-25, Safari 5.1-6 */
    background: linear-gradient(to right,
        #2c5364,
        #203a43,
        #0f2027) !important;
    /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
    background-color: #0f2027 !important;
    color: white !important;
    font-weight: bold !important;
    white-space: nowrap !important;
    text-align: center;
  }

  .custom-toolbar {
    background: linear-gradient(to right, #a8edea, #e4d0ff);
    background: linear-gradient(to right, #a8edea, #e4d0ff);
  }

  .custom-header {
    background: linear-gradient(to right, #ffe0b2, #ffccbc);

    color: black !important;
    /* Optional: makes text readable */
    font-weight: bold;
  }

  .button-77 {
    color: #fff;
    cursor: pointer;
    font-weight: 800;
    vertical-align: middle;
    z-index: 0;
  }

  /* @media (min-width: 768px) {
  .button-77 {
    padding: 19px 32px;
  }
} */

  .button-77:before,
  .button-77:after {
    border-radius: 80px;
  }

  .button-77:before {
    background-color: rgba(249, 58, 19, 0.32);
    content: "";
  }

  .button-77:after {
    background-image: linear-gradient(92.83deg, #ff7426 0, #f93a13 100%);
    bottom: 4px;
    content: "";
    display: block;
    left: 4px;
    overflow: hidden;
    position: absolute;
    right: 4px;
    top: 4px;
    transition: all 100ms ease-out;
    z-index: -1;
  }

  .button-77:hover:not(:disabled):after {
    bottom: 0;
    left: 0;
    right: 0;
    top: 0;
    transition-timing-function: ease-in;
  }

  .button-77:active:not(:disabled) {
    color: #ccc;
  }

  .button-77:active:not(:disabled):after {
    background-image: linear-gradient(0deg,
        rgba(0, 0, 0, 0.2),
        rgba(0, 0, 0, 0.2)),
      linear-gradient(92.83deg, #ff7426 0, #f93a13 100%);
    bottom: 4px;
    left: 4px;
    right: 4px;
    top: 4px;
  }

  .button-77:disabled {
    cursor: default;
    opacity: 0.24;
  }
</style>